import React from "react"
import PageTransition from 'gatsby-plugin-page-transitions';
import Layout from "../components/layout"
import VideoCover from "../components/video-cover"
import Realisation from "../components/realisation"
import SEO from "../components/seo"


import WhoAreWe from "../components/who-are-we"
import Sponsores from "../components/sponsores"
class Work extends React.Component {
  render = () => (
    
      <Layout>
        <SEO title="Nos Réalisations" keywords={[`gatsby`, `application`, `react`]} />
          <main className="scroll-jacker">
            
            <VideoCover
              title="Nous faisons de la magie."
              videoUrl="/video/positiveemotiondev.mp4" 
            />

            <h2 
              className="belt" 
              style={{ fontFamily: "inherit" }}
            >
              Chef-d'œuvre Digital
            </h2>

            <main className="manifest">
              <section className="manifest__section manifest__section--services" style={{
                padding: "0"
              }}>
                <header className="manifest__services-header manifest__services-header--toggled"></header>
                <article className="manifest__article">
                  <h2 className="manifest__article-heading">Chef-d'œuvre Digital</h2>
                  <p className="manifest__para">
                    <br /><br />
                    Le mot "IMPOSSIBLE" n'existe pas dans le langage UTOPIQUE
                    <br /><br />
                  </p>
                </article>
              </section>
            </main>

          </main>

          <Realisation />

          <Sponsores />
          <WhoAreWe />
          
      </Layout>
    
  )

  componentDidMount = () => {
  }

}

export default Work
